/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unused-vars */
document.addEventListener('DOMContentLoaded', (e) => {
  TangentAI.init()
})
const TangentAI = (function () {
  let e = [],
    t = null,
    i = null,
    n = null,
    o = !0,
    s = () => {
      let e = new URL(window.location.href),
        t = e.searchParams.get('resp_id')
      ;(i = document.getElementById('tangent-shop-market').value),
        (n = document.getElementById('tangent-shop-locale').value),
        TangentAI.fetchRecommendation(t)
          .then((e) => TangentAI.displayRecommendation(e))
          .catch((e) => {
            console.log(e)
          }),
        d()
    },
    r = async (e) => {
      if (!(t = e)) throw Error('No response ID provided')
      let n = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${t}&self_serve=true&multiple_variants=true&market=${i}`
      return fetch(n).then((e) => e.json())
    },
    l = (e) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: e.map((e) => ({
            id: e,
            quantity: 1,
          })),
        }),
      })
        .then(() => {
          TangentAI.hideProductDetailsPopup(),
            window.refreshCartAndOpenDrawer(),
            c(e)
        })
        .catch((e) => {
          console.error('Error:', e)
        })
    },
    a = (e) => {
      let t = setInterval(() => {
        window.Shopify &&
          null != window.Shopify.customerPrivacy &&
          (clearInterval(t), e())
      }, 500)
      setTimeout(() => {
        clearInterval(t)
      }, 1e4)
    },
    d = () => {
      a(() => {
        u(window.Shopify.customerPrivacy.analyticsProcessingAllowed())
      })
    },
    u = (e) => {
      o = e
    },
    h = () => o,
    c = (e) => {
      if (!h()) return
      let i = e.map((e) => {
        let t = O(e),
          i = W(t, e)
        return {
          product_id: t.id,
          variant_id: e,
          price: i.price,
          product_name: t.title,
          variant_name: i.title,
        }
      })
      fetch('https://s.tangent.ai/recommendation-track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          resp_id: t,
          event_name: 'added_to_cart',
          event_type: 'click',
          recommendation_url: `https://olaplex.com/pages/routine-recommendation?resp_id=${t}`,
          attributes: {
            products: i,
          },
        }),
      })
    },
    g = () => {
      let e = document.getElementById('user_email_input').value
      Q(e) &&
        (J(document.getElementById('email-popup-backcover')),
        fetch('https://service.tangent.ai/shopify/responses', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            shop_id: '4341661',
            form_id: '66585e5b95f1923cc3664871',
            resp_id: t,
            responses: {
              form: {
                email: e,
              },
            },
          }),
        })
          .then(() => {
            window.location.reload()
          })
          .catch((e) => {
            console.error('Error:', e)
          }))
    },
    p = (e) => {
      f(e), y(e), w(), v(e), k(e), m(e), $()
    },
    f = (e) => {
      let t = j(e.tags)
      N(t)
    },
    y = (e) => {
      let t = Object.keys(e.product_sections || {}),
        i = Object.keys(e.text_sections || {}),
        n = [...new Set(t.concat(i))]
      for (let o of n) b(o, e)
    },
    m = (e) => {
      let t = X(e),
        i = document.getElementById('client_name')
      t && i && (i.innerHTML = `${t}'s`)
    },
    b = (t, i) => {
      let n = U(t, i.text_sections),
        o = G(t, i.product_sections, i.products)
      ;(e = e.concat(o)), C(t, n, o)
    },
    w = () => {
      let e = document.getElementsByClassName('load-on-data')
      for (let t of e) Z(t)
    },
    v = (t) => {
      let i = _(t)
      ;(document.getElementById('total_amount').innerHTML = '- ' + R(i)),
        (document.getElementById('total_amount_main_section').innerHTML =
          '- ' + R(i)),
        Z(document.getElementById('all_to_cart_actions'))
      let n = []
      for (let o of e) {
        let s = W(o)
        n.push(s.id)
      }
      let r = document.querySelectorAll('.tangent_primary_button')
      r.forEach((e) =>
        e.addEventListener('click', (e) => {
          TangentAI.addVariantsToCart(n)
        })
      )
    },
    k = (e) => {
      if (q(e)) {
        J(document.getElementById('save_results_div')),
          J(document.getElementById('save_results_button_secondary_div'))
        return
      }
      let t = document.getElementById('save_results_button'),
        i = document.getElementById('save_results_button_secondary'),
        n = document.getElementById('email-popup-backcover'),
        o = document.getElementById('email_close_button_icon')
      t.addEventListener('click', function (e) {
        e.preventDefault(), Z(n)
      }),
        i.addEventListener('click', function (e) {
          e.preventDefault(), Z(n)
        }),
        o.addEventListener('click', function () {
          J(n)
        })
    },
    $ = () => {
      J(document.getElementById('tangent-page-loader'))
    },
    N = (e) => {
      document.getElementById('tangent_selfi_image').src = e
    },
    C = (e, t, i) => {
      let n = document.getElementById(`${e}_container`)
      null != n && (n.innerHTML = E(e, t) + I(e, i))
    },
    E = (e, t) =>
      t
        ? `<div id="${e}_text_container" class="section_text_container ${e}_text_container">${t}</div>`
        : '',
    I = (e, t) => {
      if (null == t || 0 == t.length) return ''
      let i = t.reduce((t, i, n) => t + B(e, n, i), '')
      return `<div id="${e}" class="section_product_container ${e}_product_container"><div id="${e}_product_grid" class="section_product_grid ${e}_product_grid">${i}</div></div>`
    },
    B = (e, t, i) => {
      let n = W(i)
      return `<div><a id="url_tangent_product_${t}" class="tangent-text-link" target="_blank" href="/products/${i.handle}?variant=${n.id}"><img id="image_tangent_product_${t}" src="${V(i)}" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text">${i.title}</p><p id="price_tangent_product_${t}" class="tangent_product_price_text">${L(n)}</p></a><div id="${e}_variant_${t}"></div><a class="tangent-product-add-btn-wrapper" id="${n.id}" onclick="TangentAI.addVariantsToCart([${n.id}])"><button class="tangent-btn-add tangent_add_to_cart_button btn btn--primary" id="${e}_cart_tangent_product_${t}_text">Add to bag</button></a><div><p class="tangent_short_descrp">${K[i.id].subtext}</p><p class="tangent_readmore"><a onclick="TangentAI.showProductDetailsPopup(${i.id})"><u>More Details</u></a></p></div><div></div></div>`
    },
    A = (t) => {
      x(M(e, t))
      let i = document.getElementById('popup-backcover')
      Z(i)
    },
    z = () => {
      let e = document.getElementById('popup-backcover')
      J(e)
    },
    x = (e) => {
      let t = W(e)
      ;(document.getElementById('popup_product_title').innerHTML = e.title),
        (document.getElementById('popup_pdt_image').src = V(e)),
        (document.getElementById('popup_section_name').innerHTML =
          K[e.id].section),
        (document.getElementById('popup_product_short_description').innerHTML =
          K[e.id].subtext),
        (document.getElementById('popup_benefits_note').innerHTML =
          K[e.id].benefits),
        (document.getElementById('whats_it_for_note').innerHTML =
          K[e.id].used_for),
        (document.getElementById('when_to_use_note').innerHTML =
          K[e.id].when_to_use),
        (document.getElementById('popup_product_price').innerHTML = L(t)),
        (document.getElementById('popup_product_link').href =
          `/products/${e.handle}?variant=${t.id}`)
      let i = document.getElementById('popup_add_to_cart')
      ;(i.dataset.variant_id = t.id), i.addEventListener('click', P)
    },
    P = (e) => {
      TangentAI.addVariantsToCart([e.target.dataset.variant_id]),
        e.preventDefault(),
        e.stopPropagation()
    },
    _ = (e) => {
      if (0 === Object.keys(e.product_sections || {}).length) return 0
      let t = 0
      for (let i in e.product_sections) {
        let n = G(i, e.product_sections, e.products)
        t = T(n, t)
      }
      return t
    },
    T = (e, t = 0) =>
      e.reduce((e, t) => {
        let i = W(t)
        return H(i) ? (e += D(i)) : e
      }, t),
    H = (e) => {
      if ('us' == i)
        return (
          null == e.inventory_management ||
          !!(e.inventory_quantity > 0) ||
          'continue' == e.inventory_policy
        )
      return e.inventoryQuantity > 0 || 'CONTINUE' == e.inventoryPolicy
    },
    D = (e) => {
      let t = null
      return Number(
        (t = 'us' == i ? e.price : e.contextualPricing.price.amount).replace(
          /[^0-9.-]+/g,
          ''
        )
      )
    },
    S = (e) => {
      if ('us' == i || 'au' == i) return '$'
      {
        let t = e.contextualPricing.price.currencyCode
        return new Intl.NumberFormat(n, {
          style: 'currency',
          currency: t,
        })
          .formatToParts('1')
          .find((e) => (e.type = 'currency')).value
      }
    },
    L = (e) => `${S(e)}${D(e)}`,
    R = (t) => {
      let i = W(e[0])
      return S(i) + t
    },
    M = (e, t) => e.find((e) => e.id == t),
    O = (t) =>
      e.find((e) =>
        'us' == i
          ? e.variants.find((e) => e.id == t)
          : e.variants.edges.find((e) => e.node.id == t)
      ),
    W = (e, t = null) => {
      if ('us' == i)
        return null !== t ? e.variants.find((e) => e.id == t) : e.variants[0]
      if (null === t)
        return (
          (e.variants.edges[0].node.id = F(e.variants.edges[0].node.id)),
          e.variants.edges[0].node
        )
      {
        let n = e.variants.edges.find((e) => e.node.id == t)
        return (n.node.id = F(n.node.id)), n.node
      }
    },
    F = (e) => (e.startsWith('gid:') ? e.split('/').pop() : e),
    V = (e) => ('us' == i ? e.image.src : e.images.nodes[0].url),
    j = (e) =>
      e.includes('straight_hair')
        ? '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Results_1440x600_Straight_1024x1024.jpg?v=13047859088099117653'
        : e.includes('wavy_hair')
          ? '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Results_1440x600_Wavy_1024x1024.jpg?v=1293165905897481420'
          : e.includes('curly_hair')
            ? '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Results_1440x600_Curly_1024x1024.jpg?v=5577256258294267387'
            : '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Results_1440x600_Coily_1024x1024.jpg?v=6455669242498194428',
    U = (e, t) => (null != t[e] ? t[e].join(' ') : null),
    G = (e, t, i) => {
      if (null == t[e]) return []
      let n = t[e]
      return n.flatMap((e) => {
        let t = M(i, e)
        return null != t ? t : []
      })
    },
    X = (e) => {
      let t = e.form
      return t.hasOwnProperty('first_name') ? t.first_name : null
    },
    q = (e) => e.email_available,
    Q = (e) =>
      String(e)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
    Z = (e) => {
      e.classList.remove('tangent-hidden'), e.classList.add('tangent-visible')
    },
    J = (e) => {
      e.classList.remove('tangent-visible'), e.classList.add('tangent-hidden')
    },
    K = {
      6570207674440: {
        title: 'No.0 Intensive Bond Building Treatment',
        section: 'Treat',
        subtext:
          'A weekly booster to pair with No.3 for even deeper repair and stronger hair.',
        used_for: 'Intensifying the results of N\xba3',
        benefits:
          '<ul><li>68% more repair and 3X stronger hair when used as a two-step system with No.3</li><li>Intensifies the results of No.3 Hair Perfector™</li></ul>',
        when_to_use: 'Weekly, before N\xba3',
      },
      5236770046024: {
        title: 'No.3 Hair Perfector™',
        subtext:
          'The weekly pre-shampoo treatment for stronger hair in as little as 3 minutes.',
        section: 'Treat',
        used_for: 'Strengthening damaged hair',
        benefits:
          '<ul><li>Stronger hair in as little as 3 minutes</li><li>Reduces breakage and split ends</li><li>Hair looks and feels healthier and stronger</li></ul>',
        when_to_use: 'Weekly, before shampoo',
      },
      5236770144328: {
        title: 'No.4 Bond Maintenance\xae Shampoo',
        subtext:
          'An every-wash hydrating shampoo for healthier-looking, softer, shinier hair with each use.',
        section: 'Cleanse',
        used_for: 'Hydrating shampoo',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates and smooths</li><li>Helps prevent frizz, split ends, and breakage</li></ul>',
        when_to_use: 'Every wash',
      },
      6573979828296: {
        title: 'No.4P Blonde Enhancer™ Toning Shampoo',
        subtext:
          'A weekly or as-needed toning purple shampoo for brighter blondes and greys.',
        section: 'Cleanse',
        used_for: 'Brightening blondes & greys',
        benefits:
          '<ul><li>Neutralizes unwanted brassy, yellow tones</li><li>Customizable brightening and toning</li><li>Cleanses without dryness</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6625961541704: {
        title: 'No.4C Bond Maintenance\xae Clarifying Shampoo',
        subtext:
          'A weekly deep-cleansing shampoo to remove buildup without dryness.',
        section: 'Cleanse',
        used_for: 'Deep cleansing hair and scalp',
        benefits:
          '<ul><li>Removes buildup of oil, hard water, product, and damaging impurities</li><li>Restores shine, body, softness, and vibrant color clarity</li><li>Deeply cleanses without stripping</li></ul>',
        when_to_use: 'Weekly, in place of regular shampoo',
      },
      6695404404808: {
        title: 'No.4D Clean Volume Detox Dry Shampoo',
        subtext:
          'The healthy-scalp dry shampoo for first-day fresh hair any time.',
        section: 'Cleanse',
        used_for: 'To refresh hair and scalp',
        benefits:
          '<ul><li>First-day fresh hair that feels just washed</li><li>Absorbs oil and neutralizes odors</li><li>Creates soft, clean, weightless body</li><li>No white residue or buildup</li></ul>',
        when_to_use: 'Between wash days',
      },
      5236770275400: {
        title: 'No.5 Bond Maintenance\xae Conditioner',
        subtext:
          'An every-wash hydrating conditioner to strengthen, nourish, and moisturize.',
        section: 'Cleanse',
        used_for: 'Nourishing conditioner',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates, smoothes, and detangles</li><li>Helps reduce breakage, frizz, and split ends</li><li>Strengthens and protects hair health</li></ul>',
        when_to_use: 'Every wash',
      },
      6771610714184: {
        title: 'No.5P Blonde Enhancer™ Toning Conditioner',
        subtext:
          'A weekly or as-needed purple shampoo for evenly toned, bright, strong blondes and greys.',
        section: 'Cleanse',
        used_for: 'Hydrating blondes & greys',
        benefits:
          '<ul><li>Locks in even tone and brightness</li><li>Hydrates, strengthens, reduces breakage</li><li>Creates healthy-looking blondes and greys</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6606290452552: {
        title: 'No.6 Bond Smoother\xae',
        subtext:
          'A smoothing styling cream for 72-hour frizz control, defined air-dries, and smoother, faster blow-dries.',
        section: 'Protect',
        used_for: 'Smoothing frizz',
        benefits:
          '<ul><li>Creates 72-hour frizz control</li><li>Smooths and hydrates</li><li>Defines air-dries and blow-dries</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      5236771160136: {
        title: 'No.7 Bonding Oil™',
        subtext:
          'A lightweight styling oil to boost shine, reduce breakage, and protect from heat.',
        section: 'Protect',
        used_for: 'Adding shine and softness',
        benefits:
          '<ul><li>Boosts shine, softness, and color vibrancy</li><li>Reduces breakage, frizz, and flyaways</li><li>Protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      6537711714376: {
        title: 'No.8 Bond Intense Moisture Mask',
        subtext:
          'A weekly reparative mask to restore weightless moisture, body, and shine.',
        section: 'Treat',
        used_for: 'Adding moisture',
        benefits:
          '<ul><li>Deeply penetrates hair to seal in nourishment</li><li>Restores weightless moisture</li><li>Restores body, shine, and smoothness</li></ul>',
        when_to_use: 'Weekly, after shampoo',
      },
      6612092846152: {
        title: 'No.9 Bond Protector Nourishing Hair Serum',
        subtext:
          'A silicone-free hair serum for style retention and protection from damaging pollution and heat.',
        section: 'Protect',
        used_for: 'Protecting against heat and pollution',
        benefits:
          '<ul><li>Promotes style retention and satin shine</li><li>Protects from pollution and heat up to 450\xb0F/ 232\xb0C</li><li>Reduces tangles and static</li></ul>',
        when_to_use: 'After every wash',
      },
      6762487185480: {
        title: 'Volumizing Blow Dry Mist',
        subtext:
          'A reparative and protective mist for faster, healthier-looking blowouts and lasting body and bounce.',
        section: 'Protect',
        used_for: 'Building body and volume',
        benefits:
          '<ul><li>Leaves lasting body, bounce, softness, and shine</li><li>Creates faster, healthier-looking blowouts</li><li>Repairs and protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'During blowouts, and for day-after styling',
      },
      6886831358024: {
        title: 'No.5 LEAVE-IN™ MOISTURIZE & MEND LEAVE-IN CONDITIONER',
        subtext:
          'A post-wash leave-in conditioner to instantly moisturize hair and seal split ends.',
        section: 'Protect',
        used_for: 'Hydrating hair and sealing split ends',
        benefits:
          '<ul><li>Instantly hydrate, soften, and detangle</li><li>Immediately seal split ends</li><li>Continuously repair and protect</li></ul>',
        when_to_use:
          "On wash days, after you've cleansed and conditioned your hair in the shower.",
      },
      6886965051464: {
        title: 'No.10 BOND SHAPER™ CURL DEFINING GEL',
        subtext:
          'A flexible hold curl-styling gel to repair, strengthen, and define curls while providing 72-hour frizz control.',
        section: 'Protect',
        used_for: 'Defining and smoothing waves, curls, and coils',
        benefits:
          '<ul><li>72-hour frizz control*</li><li>3X greater curl retention*</li><li>Smoother, easier detangling, & more conditioned*</li></ul>*Clinically proven',
        when_to_use: 'During blowouts, and for day-after styling',
      },
      6826883022920: {
        title: 'No.0 Intensive Bond Building Treatment',
        section: 'Treat',
        subtext:
          'A weekly booster to pair with No.3 for even deeper repair and stronger hair.',
        used_for: 'Intensifying the results of N\xba3',
        benefits:
          '<ul><li>68% more repair and 3X stronger hair when used as a two-step system with No.3</li><li>Intensifies the results of No.3 Hair Perfector™</li></ul>',
        when_to_use: 'Weekly, before N\xba3',
      },
      6829987954760: {
        title: 'No.3 Hair Perfector™',
        subtext:
          'The weekly pre-shampoo treatment for stronger hair in as little as 3 minutes.',
        section: 'Treat',
        used_for: 'Strengthening damaged hair',
        benefits:
          '<ul><li>Stronger hair in as little as 3 minutes</li><li>Reduces breakage and split ends</li><li>Hair looks and feels healthier and stronger</li></ul>',
        when_to_use: 'Weekly, before shampoo',
      },
      6805873950792: {
        title: 'No.4 Bond Maintenance\xae Shampoo',
        subtext:
          'An every-wash hydrating shampoo for healthier-looking, softer, shinier hair with each use.',
        section: 'Cleanse',
        used_for: 'Hydrating shampoo',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates and smooths</li><li>Helps prevent frizz, split ends, and breakage</li></ul>',
        when_to_use: 'Every wash',
      },
      6832101195848: {
        title: 'No.4P Blonde Enhancer™ Toning Shampoo',
        subtext:
          'A weekly or as-needed toning purple shampoo for brighter blondes and greys.',
        section: 'Cleanse',
        used_for: 'Brightening blondes & greys',
        benefits:
          '<ul><li>Neutralizes unwanted brassy, yellow tones</li><li>Customizable brightening and toning</li><li>Cleanses without dryness</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6830011121736: {
        title: 'No.4C Bond Maintenance\xae Clarifying Shampoo',
        subtext:
          'A weekly deep-cleansing shampoo to remove buildup without dryness.',
        section: 'Cleanse',
        used_for: 'Deep cleansing hair and scalp',
        benefits:
          '<ul><li>Removes buildup of oil, hard water, product, and damaging impurities</li><li>Restores shine, body, softness, and vibrant colour clarity</li><li>Deeply cleanses without stripping</li></ul>',
        when_to_use: 'Weekly, in place of regular shampoo',
      },
      6695404437576: {
        title: 'No.4D Clean Volume Detox Dry Shampoo',
        subtext:
          'The healthy-scalp dry shampoo for first-day fresh hair any time.',
        section: 'Cleanse',
        used_for: 'To refresh hair and scalp',
        benefits:
          '<ul><li>First-day fresh hair that feels just washed</li><li>Absorbs oil and neutralizes odors</li><li>Creates soft, clean, weightless body</li><li>No white residue or buildup</li></ul>',
        when_to_use: 'Between wash days',
      },
      6805880832072: {
        title: 'No.5 Bond Maintenance\xae Conditioner',
        subtext:
          'An every-wash hydrating conditioner to strengthen, nourish, and moisturize.',
        section: 'Cleanse',
        used_for: 'Nourishing conditioner',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates, smoothes, and detangles</li><li>Helps reduce breakage, frizz, and split ends</li><li>Strengthens and protects hair health</li></ul>',
        when_to_use: 'Every wash',
      },
      6847578767432: {
        title: 'No.5P Blonde Enhancer™ Toning Conditioner',
        subtext:
          'A weekly or as-needed purple shampoo for evenly toned, bright, strong blondes and greys.',
        section: 'Cleanse',
        used_for: 'Hydrating blondes & greys',
        benefits:
          '<ul><li>Locks in even tone and brightness</li><li>Hydrates, strengthens, reduces breakage</li><li>Creates healthy-looking blondes and greys</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6838465265736: {
        title: 'No.6 Bond Smoother\xae',
        subtext:
          'A smoothing styling cream for 72-hour frizz control, defined air-dries, and smoother, faster blow-dries.',
        section: 'Protect',
        used_for: 'Smoothing frizz',
        benefits:
          '<ul><li>Creates 72-hour frizz control</li><li>Smooths and hydrates</li><li>Defines air-dries and blow-dries</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      6797618643016: {
        title: 'No.7 Bonding Oil™',
        subtext:
          'A lightweight styling oil to boost shine, reduce breakage, and protect from heat.',
        section: 'Protect',
        used_for: 'Adding shine and softness',
        benefits:
          '<ul><li>Boosts shine, softness, and colour vibrancy</li><li>Reduces breakage, frizz, and flyaways</li><li>Protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      6843505573960: {
        title: 'No.8 Bond Intense Moisture Mask',
        subtext:
          'A weekly reparative mask to restore weightless moisture, body, and shine.',
        section: 'Treat',
        used_for: 'Adding moisture',
        benefits:
          '<ul><li>Deeply penetrates hair to seal in nourishment</li><li>Restores weightless moisture</li><li>Restores body, shine, and smoothness</li></ul>',
        when_to_use: 'Weekly, after shampoo',
      },
      6843517173832: {
        title: 'No.9 Bond Protector Nourishing Hair Serum',
        subtext:
          'A silicone-free hair serum for style retention and protection from damaging pollution and heat.',
        section: 'Protect',
        used_for: 'Protecting against heat and pollution',
        benefits:
          '<ul><li>Promotes style retention and satin shine</li><li>Protects from pollution and heat up to 450\xb0F/ 232\xb0C</li><li>Reduces tangles and static</li></ul>',
        when_to_use: 'After every wash',
      },
      6845538566216: {
        title: 'Volumizing Blow Dry Mist',
        subtext:
          'A reparative and protective mist for faster, healthier-looking blowouts and lasting body and bounce.',
        section: 'Protect',
        used_for: 'Building body and volume',
        benefits:
          '<ul><li>Leaves lasting body, bounce, softness, and shine</li><li>Creates faster, healthier-looking blowouts</li><li>Repairs and protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'During blowouts, and for day-after styling',
      },
      6886831685704: {
        title: 'No.5 LEAVE-IN™ MOISTURIZE & MEND LEAVE-IN CONDITIONER',
        subtext:
          'A post-wash leave-in conditioner to instantly moisturize hair and seal split ends.',
        section: 'Protect',
        used_for: 'Hydrating hair and sealing split ends',
        benefits:
          '<ul><li>Instantly hydrate, soften, and detangle</li><li>Immediately seal split ends</li><li>Continuously repair and protect</li></ul>',
        when_to_use:
          "On wash days, after you've cleansed and conditioned your hair in the shower.",
      },
      6886965608520: {
        title: 'No.10 BOND SHAPER™ CURL DEFINING GEL',
        subtext:
          'A flexible hold curl-styling gel to repair, strengthen, and define curls while providing 72-hour frizz control.',
        section: 'Protect',
        used_for: 'Defining and smoothing waves, curls, and coils',
        benefits:
          '<ul><li>72-hour frizz control*</li><li>3X greater curl retention*</li><li>Smoother, easier detangling, & more conditioned*</li></ul>*Clinically proven',
        when_to_use: 'During blowouts, and for day-after styling',
      },
      6826883121224: {
        title: 'No.0 Intensive Bond Building Treatment',
        section: 'Treat',
        subtext:
          'A weekly booster to pair with No.3 for even deeper repair and stronger hair.',
        used_for: 'Intensifying the results of N\xba3',
        benefits:
          '<ul><li>68% more repair and 3X stronger hair when used as a two-step system with No.3</li><li>Intensifies the results of No.3 Hair Perfector™</li></ul>',
        when_to_use: 'Weekly, before N\xba3',
      },
      6829988151368: {
        title: 'No.3 Hair Perfector™',
        subtext:
          'The weekly pre-shampoo treatment for stronger hair in as little as 3 minutes.',
        section: 'Treat',
        used_for: 'Strengthening damaged hair',
        benefits:
          '<ul><li>Stronger hair in as little as 3 minutes</li><li>Reduces breakage and split ends</li><li>Hair looks and feels healthier and stronger</li></ul>',
        when_to_use: 'Weekly, before shampoo',
      },
      6831778627656: {
        title: 'No.4 Bond Maintenance\xae Shampoo',
        subtext:
          'An every-wash hydrating shampoo for healthier-looking, softer, shinier hair with each use.',
        section: 'Cleanse',
        used_for: 'Hydrating shampoo',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates and smooths</li><li>Helps prevent frizz, split ends, and breakage</li></ul>',
        when_to_use: 'Every wash',
      },
      6832101261384: {
        title: 'No.4P Blonde Enhancer™ Toning Shampoo',
        subtext:
          'A weekly or as-needed toning purple shampoo for brighter blondes and greys.',
        section: 'Cleanse',
        used_for: 'Brightening blondes & greys',
        benefits:
          '<ul><li>Neutralizes unwanted brassy, yellow tones</li><li>Customizable brightening and toning</li><li>Cleanses without dryness</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6830011383880: {
        title: 'No.4C Bond Maintenance\xae Clarifying Shampoo',
        subtext:
          'A weekly deep-cleansing shampoo to remove buildup without dryness.',
        section: 'Cleanse',
        used_for: 'Deep cleansing hair and scalp',
        benefits:
          '<ul><li>Removes buildup of oil, hard water, product, and damaging impurities</li><li>Restores shine, body, softness, and vibrant colour clarity</li><li>Deeply cleanses without stripping</li></ul>',
        when_to_use: 'Weekly, in place of regular shampoo',
      },
      6800477356104: {
        title: 'No.4D Clean Volume Detox Dry Shampoo',
        subtext:
          'The healthy-scalp dry shampoo for first-day fresh hair any time.',
        section: 'Cleanse',
        used_for: 'To refresh hair and scalp',
        benefits:
          '<ul><li>First-day fresh hair that feels just washed</li><li>Absorbs oil and neutralizes odors</li><li>Creates soft, clean, weightless body</li><li>No white residue or buildup</li></ul>',
        when_to_use: 'Between wash days',
      },
      6837199339592: {
        title: 'No.5 Bond Maintenance\xae Conditioner',
        subtext:
          'An every-wash hydrating conditioner to strengthen, nourish, and moisturize.',
        section: 'Cleanse',
        used_for: 'Nourishing conditioner',
        benefits:
          '<ul><li>Healthier-looking, softer, shinier hair with every wash</li><li>Hydrates, smoothes, and detangles</li><li>Helps reduce breakage, frizz, and split ends</li><li>Strengthens and protects hair health</li></ul>',
        when_to_use: 'Every wash',
      },
      6847578898504: {
        title: 'No.5P Blonde Enhancer™ Toning Conditioner',
        subtext:
          'A weekly or as-needed purple shampoo for evenly toned, bright, strong blondes and greys.',
        section: 'Cleanse',
        used_for: 'Hydrating blondes & greys',
        benefits:
          '<ul><li>Locks in even tone and brightness</li><li>Hydrates, strengthens, reduces breakage</li><li>Creates healthy-looking blondes and greys</li></ul>',
        when_to_use: 'Weekly, or as needed to tone brassiness',
      },
      6838465331272: {
        title: 'No.6 Bond Smoother\xae',
        subtext:
          'A smoothing styling cream for 72-hour frizz control, defined air-dries, and smoother, faster blow-dries.',
        section: 'Protect',
        used_for: 'Smoothing frizz',
        benefits:
          '<ul><li>Creates 72-hour frizz control</li><li>Smooths and hydrates</li><li>Defines air-dries and blow-dries</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      6775682498632: {
        title: 'No.7 Bonding Oil™',
        subtext:
          'A lightweight styling oil to boost shine, reduce breakage, and protect from heat.',
        section: 'Protect',
        used_for: 'Adding shine and softness',
        benefits:
          '<ul><li>Boosts shine, softness, and colour vibrancy</li><li>Reduces breakage, frizz, and flyaways</li><li>Protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'After every wash, or on styling days',
      },
      6843505606728: {
        title: 'No.8 Bond Intense Moisture Mask',
        subtext:
          'A weekly reparative mask to restore weightless moisture, body, and shine.',
        section: 'Treat',
        used_for: 'Adding moisture',
        benefits:
          '<ul><li>Deeply penetrates hair to seal in nourishment</li><li>Restores weightless moisture</li><li>Restores body, shine, and smoothness</li></ul>',
        when_to_use: 'Weekly, after shampoo',
      },
      6843517239368: {
        title: 'No.9 Bond Protector Nourishing Hair Serum',
        subtext:
          'A silicone-free hair serum for style retention and protection from damaging pollution and heat.',
        section: 'Protect',
        used_for: 'Protecting against heat and pollution',
        benefits:
          '<ul><li>Promotes style retention and satin shine</li><li>Protects from pollution and heat up to 450\xb0F/ 232\xb0C</li><li>Reduces tangles and static</li></ul>',
        when_to_use: 'After every wash',
      },
      6845530734664: {
        title: 'Volumizing Blow Dry Mist',
        subtext:
          'A reparative and protective mist for faster, healthier-looking blowouts and lasting body and bounce.',
        section: 'Protect',
        used_for: 'Building body and volume',
        benefits:
          '<ul><li>Leaves lasting body, bounce, softness, and shine</li><li>Creates faster, healthier-looking blowouts</li><li>Repairs and protects from heat up to 450\xb0F/ 232\xb0C</li></ul>',
        when_to_use: 'During blowouts, and for day-after styling',
      },
      6886831816776: {
        title: 'No.5 LEAVE-IN™ MOISTURIZE & MEND LEAVE-IN CONDITIONER',
        subtext:
          'A post-wash leave-in conditioner to instantly moisturize hair and seal split ends.',
        section: 'Protect',
        used_for: 'Hydrating hair and sealing split ends',
        benefits:
          '<ul><li>Instantly hydrate, soften, and detangle</li><li>Immediately seal split ends</li><li>Continuously repair and protect</li></ul>',
        when_to_use:
          "On wash days, after you've cleansed and conditioned your hair in the shower.",
      },
      6886965674056: {
        title: 'No.10 BOND SHAPER™ CURL DEFINING GEL',
        subtext:
          'A flexible hold curl-styling gel to repair, strengthen, and define curls while providing 72-hour frizz control.',
        section: 'Protect',
        used_for: 'Defining and smoothing waves, curls, and coils',
        benefits:
          '<ul><li>72-hour frizz control*</li><li>3X greater curl retention*</li><li>Smoother, easier detangling, & more conditioned*</li></ul>*Clinically proven',
        when_to_use: 'During blowouts, and for day-after styling',
      },
    }
  return {
    init: s,
    fetchRecommendation: r,
    displayRecommendation: p,
    showProductDetailsPopup: A,
    hideProductDetailsPopup: z,
    addVariantsToCart: l,
    submitEmail: g,
  }
})()
